import {InputMode} from './const';
import {useAppState} from 'store/utils';

export function useUserInputStore(): UserInputState {
  return useAppState().userInput;
}

export function useKeyboard(): KeyboardState {
  return useUserInputStore().keyboard;
}

export function useInputMode(): UserInputMode {
  return useUserInputStore().inputMode;
}

type ModeDeterminant = (mode: UserInputMode) => boolean;

export function is(expected: UserInputMode): ModeDeterminant {
  return (mode) => mode === expected;
}

export const isSpend = is(InputMode.Spend);
export const isRefill = is(InputMode.Refill);
export const isIncome = is(InputMode.Income);

export function useIsIncomeMode(): boolean {
  const mode = useInputMode();
  return isIncome(mode);
}
